import React, { useState, useEffect, useRef } from 'react';
import {
  FaDownload,
  FaShare,
  FaLink,
  FaMailBulk,
  FaAngleDown,
  FaAngleUp,
  FaCheckCircle,
} from 'react-icons/fa';
import {
  portfolioWebsiteUrl,
  homeTextButtonColor,
  myResume,
  myResumeName,
} from './constants';

const HomeButtons = () => {
  const [optionsVisible, setOptionsVisible] = useState(false);
  const [optionsVisibleIcon, setOptionsVisibleIcon] = useState('FaAngleDown');
  const [successMessage, setSuccessMessage] = useState({
    visible: false,
    text: '',
  });

  const shareButtonRef = useRef(null);
  const optionsSectionRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        shareButtonRef.current &&
        !shareButtonRef.current.contains(event.target) &&
        optionsSectionRef.current &&
        !optionsSectionRef.current.contains(event.target)
      ) {
        setOptionsVisible(false); //the click occurred outside both the share button and the options section
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setOptionsVisibleIcon(optionsVisible ? 'FaAngleUp' : 'FaAngleDown');
  }, [optionsVisible]);

  const handleShareButtonClick = () => {
    console.log('called handleShareButtonClick');

    setOptionsVisible((prevState) => !prevState);

    // setOptionsVisible(!optionsVisible);

    // if (!optionsVisible) {
    //   setOptionsVisibleIcon(FaAngleUp);
    // } else {
    //   setOptionsVisibleIcon(FaAngleDown);
    // }
  };

  const handleDownloadResume = () => {
    const link = document.createElement('a');
    link.href = myResume;
    link.download = myResumeName;
    link.click();
  };

  const handleCopyToClipboard = () => {
    navigator.clipboard
      .writeText(portfolioWebsiteUrl)
      .then(() => {
        setSuccessMessage({
          visible: true,
          text: 'Copied to clipboard!',
        });
        setTimeout(() => {
          setSuccessMessage({
            visible: false,
            text: '',
          });
        }, 3000);
      })
      .catch((error) => {
        console.error('Failed to copy URL to clipboard:', error);
      });
  };

  const handleEmailColleague = () => {
    const emailSubject = 'Profile for consideration';
    const emailBody = `Hi,
      
        I hope this email finds you well. I wanted to take a moment to refer a talented candidate who might be a great fit for our team. I recently came across their portfolio website and was truly impressed by their skills and accomplishments.

        I encourage you to take a look at their portfolio at the following link: ${portfolioWebsiteUrl}
        It showcases their expertise, projects, and passion. I believe their skills and experience would be a valuable asset to our organization.

        Thank you for considering this referral. If you have any questions or need further information, please don't hesitate to reach out. I look forward to hearing positive news about this candidate.

Best regards`;

    const mailToUrl = `mailto:?subject=${encodeURIComponent(
      emailSubject
    )}&body=${encodeURIComponent(emailBody)}`;

    setSuccessMessage({
      visible: true,
      text: 'Opening default email application!',
    });
    setTimeout(() => {
      setSuccessMessage({
        visible: false,
        text: '',
      });
    }, 3000);

    window.location.href = mailToUrl;
  };

  return (
    <div style={styles.buttonSection}>
      <button style={styles.downloadButton} onClick={handleDownloadResume}>
        {/* <button style={styles.downloadButton}> */}
        {/* <a href={myResume} download> */}
        <FaDownload
          style={{ ...styles.buttonIcon, color: homeTextButtonColor }}
        />
        Download my resume
        {/* </a> */}
      </button>

      <button
        style={styles.shareButton}
        onClick={handleShareButtonClick}
        ref={shareButtonRef}
      >
        <FaShare style={{ ...styles.buttonIcon, color: homeTextButtonColor }} />
        Share my website
        {/* {optionsVisible ? ( */}
        {optionsVisibleIcon === 'FaAngleDown' ? (
          <FaAngleDown
            style={{ ...styles.buttonIcon, color: homeTextButtonColor }}
          />
        ) : (
          <FaAngleUp
            style={{ ...styles.buttonIcon, color: homeTextButtonColor }}
          />
        )}
      </button>

      {optionsVisible && (
        <div style={styles.optionSection} ref={optionsSectionRef}>
          <button style={styles.option1} onClick={handleCopyToClipboard}>
            <FaLink style={styles.buttonIcon} />
            Copy Link To Clipboard
          </button>
          <button style={styles.option2} onClick={handleEmailColleague}>
            <FaMailBulk style={styles.buttonIcon} />
            Email a colleague
          </button>
        </div>
      )}

      {successMessage.visible && (
        <div style={styles.successMessage}>
          <div style={styles.successIcon}>
            <FaCheckCircle style={styles.successIconCircle} />
          </div>
          <div style={styles.successText}>{successMessage.text}</div>
        </div>
      )}
    </div>
  );
};

const styles = {
  optionSection: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#FFDAB9',
    borderRadius: '15px',
    width: '205px',
  },
  option1: {
    width: '205px',
    height: '30px',
    backgroundColor: 'transparent',
    border: 'none',
    textAlign: 'left',
    paddingLeft: '20px',
    // padding: '10px 10px',
    alignItems: 'center',
  },
  option2: {
    width: '205px',
    height: '30px',
    backgroundColor: 'transparent',
    border: 'none',
    textAlign: 'left',
    paddingLeft: '20px',
    // padding: '10px 10px',
    alignItems: 'center',
  },
  buttonSection: {
    marginTop: '20px',
    display: 'flex',
    flexDirection: 'column',
    // gap: '10px',
    position: 'relative', // Add position relative to the container
    justifyContent: 'center',
    alignItems: 'center',
  },
  downloadButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    padding: '10px 20px',
    backgroundColor: '#ffd814',
    // color: '#000',
    border: 'none',
    cursor: 'pointer',
    width: '205px',
    height: '30px',
    borderRadius: '15px',
    marginBottom: '8px',
    color: homeTextButtonColor,
  },
  shareButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    padding: '10px 20px',
    backgroundColor: '#ffa41c',
    // color: '#000',
    border: 'none',
    cursor: 'pointer',
    width: '205px',
    height: '30px',
    borderRadius: '15px',
    color: homeTextButtonColor,
  },
  buttonIcon: {
    fontSize: '18px',
    marginRight: '5px',
  },
  successMessage: {
    position: 'fixed',
    bottom: '80px',
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#000',
    color: '#fff',
    borderRadius: '5px',
    padding: '10px 20px',
    zIndex: 9999,
  },
  successIcon: {
    marginRight: '10px',
  },
  successIconCircle: {
    color: 'green',
    fontSize: '18px',
  },
  successText: {
    fontSize: '14px',
  },
};

export default HomeButtons;
